export const setMetaTags = (node, lang) => {
    if (node[lang].title) {
        document.title = node[lang].title;
    }
    setMetaByName('description', node[lang].description);
    setMetaByProperty('og:type', node[lang].og_type);
    setMetaByProperty('og:title', node[lang].og_title);
    setMetaByProperty('og:description', node[lang].og_description);
    setMetaByProperty('og:url', node[lang].og_url);
    setMetaByProperty('og:image', node[lang].og_image);
    setMetaByProperty('og:image:alt', node[lang].og_image_alt);
};

export const setMetaByName = (key, value) => {
    if (value && value !== '') {
        document.querySelector(`meta[name="${key}"]`).setAttribute('content', value);
    }
};

export const setMetaByProperty = (key, value) => {
    if (value && value !== '') {
        document.querySelector(`meta[property="${key}"]`).setAttribute('content', value);
    }
};
